// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config, spacing } = window.BAO.Carousel
const {
  setInitialised,
  useArrows,
  addWheelControls,
} = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils
class ProductCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 500)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupCarousel () {
    return new KeenSlider(this.els.slides.element, this.options(), [
      setInitialised(),
      useArrows({
        next: this.els?.next?.element,
        previous: this.els?.previous?.element,
      }),
      addWheelControls('horizontal'),
    ])
  }

  options () {
    return {
      selector: this.els.slide.selector,
      loop: false,
      mode: 'free-snap',
      defaultAnimation: {
        duration: config.defaultAnimation.duration,
      },
      dragSpeed: config.dragSpeed,
      slides: {
        perView: 'auto',
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 'auto',
            spacing: spacing(),
          },
        },
      },
    }
  }

  onResize () {
    if (!this.carousel) return
    this.carousel.update(this.options(), this.carousel.track.details.rel)
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
